// eslint-disable-next-line import/no-anonymous-default-export
export default {
  locale: 'pt-br',
  invalid_rrule: "You provided an invalid RRule value to component. '%{value}' is not a correct RRule string.",
  months: {
    jan: 'Jan',
    feb: 'Fev',
    mar: 'Mar',
    apr: 'Abr',
    may: 'Mai',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Ago',
    sep: 'Set',
    oct: 'Out',
    nov: 'Nov',
    dec: 'Dez',
  },
  days_short: {
    mon: 'Seg',
    tue: 'Ter',
    wed: 'Qua',
    thu: 'Qui',
    fri: 'Sex',
    sat: 'Sab',
    sun: 'Dom',
  },
  days: {
    monday: 'Segunda',
    tuesday: 'Terça',
    wednesday: 'Quarta',
    thursday: 'Quinta',
    friday: 'Sexta',
    saturday: 'Sábada',
    sunday: 'Domingo',
    day: 'Dia',
    weekday: 'Semana',
    'weekend day': 'Fim de semana',
  },
  numerals: {
    first: 'Primeira',
    second: 'Segunda',
    third: 'Terceira',
    fourth: 'Quarta',
    last: 'Última',
  },
  start: {
    label: 'Início',
    tooltip: 'Selecione uma dia e hora para a data de inicio',
  },
  repeat: {
    label: 'Repetir',
    yearly: {
      label: 'Anualmente',
      on: 'em',
      on_the: 'na',
      of: 'de',
    },
    monthly: {
      label: 'Mensalmente',
      every: 'a cada',
      months: 'mês(es)',
      on_day: 'no dia',
      on_the: 'na',
    },
    weekly: {
      label: 'Semanalmente',
      every: 'a cada',
      weeks: 'semana(s)',
    },
    daily: {
      label: 'Diariamente',
      every: 'a cada',
      days: 'dia(s)',
    },
    hourly: {
      label: 'Por hora',
      every: 'a cada',
      hours: 'hora(s)',
    },
  },
  end: {
    label: 'Termina',
    tooltip: 'Selecione a data de término.',
    never: 'Nunca',
    after: 'Depois de',
    on_date: 'Na data',
    executions: 'execução(ões).',
  },
};
